// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6bf05e52] label:not(.custom-control-label) {\n  color: #6c757d !important;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
